import React from "react";
import { PeekStack } from "@piiqtechnologies/ui-components";
import { UserTypeSelector } from "../../UserTypeSelector";
import { USER_ROLES } from "@constants/Roles";
export const LeasingAccessSection = ({ field, form, label, isAdminForm }) => {
    const rolesOptions = [
        USER_ROLES.Basic,
        USER_ROLES.Agent,
        isAdminForm && USER_ROLES.Scanner,
        isAdminForm && USER_ROLES.Owner,
        USER_ROLES.OrgAdmin,
    ].filter(Boolean);
    return (React.createElement(PeekStack, { spacing: 1 },
        React.createElement(UserTypeSelector, { field: field, form: form, label: label, placeholder: "", rolesOptions: rolesOptions, communities: [] })));
};
export default LeasingAccessSection;
